// Shared basemap configuration.
//
// CARTO's anonymous raster tiles now stamp "API KEY REQUIRED" across the map.
// Esri's World Light Gray Canvas is free, keyless and looks like the light
// basemap we had before (light land, subtle roads), with a separate labels
// layer on top.
import L from 'leaflet';

export const MAP_ATTRIBUTION = '&copy; Esri, &copy; OpenStreetMap contributors';

export const MAP_TILE_URL =
  'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}';

export const MAP_LABELS_URL =
  'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Reference/MapServer/tile/{z}/{y}/{x}';

export const MAP_TILE_OPTIONS: L.TileLayerOptions = {
  maxZoom: 19,
  maxNativeZoom: 16,
  attribution: MAP_ATTRIBUTION,
};

/**
 * Adds the light-gray basemap (plus labels) to a Leaflet map instance.
 */
export function addBasemap(map: L.Map): L.Layer {
  const base = new L.TileLayer(MAP_TILE_URL, MAP_TILE_OPTIONS);
  base.addTo(map);

  const labels = new L.TileLayer(MAP_LABELS_URL, {
    maxZoom: 19,
    maxNativeZoom: 16,
    pane: 'shadowPane',
  });
  labels.addTo(map);

  return base;
}
